module.exports = __webpack_public_path__ + "static/media/axisloader_grey.ab48652d.gif";